{
  "page": {
    "title": "Rider Database",
    "subtitle": "{count} riders",
    "watchlistLink": "My Watchlist ({count})",
    "loadingAria": "Loading riders"
  },
  "loadError": "Couldn't load the riders. Please try again.",
  "retry": "Try again",
  "watchlistToggleFailed": "Could not update your watchlist. Please try again.",
  "table": {
    "nation": "Nation",
    "rider": "Rider",
    "rating": "Rating",
    "ratingTitle": "The weighted average of the abilities his own role needs. The same number means the same level in any role.",
    "team": "Team",
    "badges": "Status",
    "age": "Age",
    "value": "Value",
    "salary": "Salary",
    "popularity": "Popularity",
    "popularityTitle": "Fan popularity (0-100). Existing board star-rider goals keep the measure they were agreed under.",
    "reputationLabel": "Reputation",
    "reputationTitle": "Race reputation. During the transition, it never shows below this rider's old popularity. The board reads this number for new profile goals.",
    "reputation": {
      "band": {
        "unknown": "Unknown",
        "known": "Known",
        "profile": "Profile",
        "star": "Star",
        "legend": "Legend"
      }
    },
    "compareTooltip": "Select for comparison",
    "teamFree": "Free",
    "pendingTransfer": "Transfer pending: joining {team} once his current stage race finishes"
  },
  "abilityLegend": {
    "toggle": "What do the codes mean?"
  },
  "mobileSort": {
    "label": "Sort by",
    "ascAria": "Sorting ascending, tap for descending",
    "descAria": "Sorting descending, tap for ascending"
  },
  "pagination": {
    "showing": "Showing {from}-{to} of {total}",
    "prev": "Previous",
    "next": "Next"
  },
  "tour": {
    "filters": {
      "title": "Filter the list to your budget",
      "body": "Set 'Value max' to your balance to see only riders you can afford. The U25 / Free agent toggles open up cheaper paths."
    },
    "list": {
      "title": "Click a rider",
      "body": "The detail page shows full stats, contract status, and buy/auction options. You can start an auction or send an offer from there."
    },
    "watchlist": {
      "title": "Use the watchlist",
      "body": "The star adds the rider to your watchlist so you can come back easily. The list also lives in the menu under Market: Watchlist."
    }
  },
  "emptyState": {
    "title": "Build your first team",
    "intro": "You have no riders yet. Use the filters below to find the riders that fit your strategy and budget.",
    "balance": "Your balance",
    "tipValue": "<strong>Value filters</strong> = price ceiling in CZ$. Set max below your balance to see only affordable riders.",
    "tipStats": "<strong>Stat filters</strong> = rider abilities like climbing, sprinting and time-trialling. Start broad and narrow down later.",
    "tipBudget": "<strong>U25 / Free agent</strong> = budget-friendly paths: younger potential or riders without a contract.",
    "ctaFindFirst": "Find your first rider (≤ {balance} CZ$)",
    "ctaTour": "Show me around"
  },
  "rankings": {
    "title": "Rider rankings",
    "season": "Season {n}",
    "noActiveSeason": "No active season",
    "completedSeasonNote": "· Completed season. The new season has not started yet.",
    "ridersCount": "{count} riders",
    "filterIndicator": "Showing Division {division}",
    "divisionFilterLabel": "Filter by division",
    "divisionFilterAll": "All divisions",
    "divisionFilterOption": "Division {n}",
    "poolFilterLabel": "Filter by pool",
    "poolFilterAll": "All pools",
    "ownerFilterLabel": "Filter by owner",
    "searchPlaceholder": "Search rider name…",
    "noResults": "No results found",
    "noResultsFor": "No results found for \"{q}\"",
    "loadError": "Couldn't load the rankings. Please try again.",
    "retry": "Try again",
    "thNation": "Nation",
    "thRider": "Rider",
    "thTeam": "Team",
    "thBadges": "Status",
    "teamFree": "Free agent",
    "ownerAll": "All",
    "ownerManager": "Manager-owned",
    "ownerAi": "AI-owned",
    "ownerFree": "Free agents",
    "teamFilterLabel": "Filter by team",
    "teamFilterAll": "All teams",
    "colPoints": "Points",
    "colTotalWins": "Total wins",
    "colStageWins": "Stage wins",
    "colGcWins": "GC wins",
    "colClassicWins": "Classic wins",
    "colPtsWins": "Points classification",
    "colMtnWins": "Mountains classification",
    "colYoungWins": "Youth classification",
    "colPrize": "Prize won",
    "colTop3": "Top 3",
    "colTop10": "Top 10",
    "colYellowDays": "Yellow days",
    "colGreenDays": "Green days",
    "colPolkaDays": "Polka days",
    "colWhiteDays": "White days",
    "shortPoints": "Pts",
    "shortTotalWins": "Wins",
    "shortStageWins": "Stage",
    "shortGcWins": "GC",
    "shortClassicWins": "Cls",
    "shortPtsWins": "PCL",
    "shortMtnWins": "Mtn",
    "shortYoungWins": "U25",
    "shortPrize": "Prize",
    "shortTop3": "T3",
    "shortTop10": "T10",
    "shortYellowDays": "Yel",
    "shortGreenDays": "Grn",
    "shortPolkaDays": "Pol",
    "shortWhiteDays": "Wht",
    "columnsButton": "Columns",
    "columnsHeading": "Show columns",
    "legendStage": "Stage = stage wins",
    "legendGc": "GC = overall stage-race wins",
    "legendClassic": "Cls = one-day classic wins",
    "legendPcl": "PCL = points classification",
    "legendMtn": "Mtn = mountains classification",
    "legendU25": "U25 = youth classification",
    "legendSort": "Click a column to sort"
  }
}
